import { render, staticRenderFns } from "./addWhiteList.vue?vue&type=template&id=4083b80a&scoped=true&"
import script from "./addWhiteList.vue?vue&type=script&lang=js&"
export * from "./addWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./addWhiteList.vue?vue&type=style&index=0&id=4083b80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083b80a",
  null
  
)

export default component.exports